import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "alert alert-info d-flex align-items-center",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " Sie können einen öffentlichen Kommentar zu dieser Meldung einschicken. Nutzen Sie diese Möglichkeit, wenn das Anliegen z.B. bereits behoben wurde oder sich die Situation grundlegend verändert hat. Sie können dazu auch ein Foto hochladen, das den neuen Stand dokumentiert. ", -1)
const _hoisted_3 = {
  class: "alert alert-info d-flex align-items-center",
  role: "alert"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Hinweis: Meldende sind bereits automatisch für ihre eigenen Meldungen abonniert.", -1)
const _hoisted_5 = {
  id: "wdw-filter-form",
  class: "wdw-form mt-4"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("   ")

import domainRepository from '@/api/domainRepository';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
// eslint-disable-next-line
//@ts-ignore
import { TextArea as FormControlTextarea } from 'wdw-library/dist/esm/TextArea';
// eslint-disable-next-line
//@ts-ignore
import { File as FormControlFile } from 'wdw-library/dist/esm/File';
// eslint-disable-next-line
//@ts-ignore
import { Checkbox as FormControlCheckbox } from 'wdw-library/dist/esm/Checkbox';
import Captcha from '@/components/general/Captcha.vue';
import { bms } from '@/composables/general/useDomainSettings';
import { userStore } from '@/store/user-store';
import { Form } from 'vee-validate';
import { computed, ref } from 'vue';
import useConverter from '@/composables/general/useConverter';


export default /*#__PURE__*/_defineComponent({
  props: { messageid: { type: Number, required: true } },
  emits: ['cancel', 'submit'],
  setup(__props, { emit }) {

const props = __props



const { toBool } = useConverter();

const uploadFile = ref();
const captcha = ref<InstanceType<typeof Captcha>>();
const captchaId = ref(0);
const captchaError = ref('');
const captchaValidated = ref(false);
const user = computed(() => userStore.getState().user);
const submitting = ref(false);

// Computed
const userIsAdmin = computed(() => {
  return user.value?.type == 'admin';
});
const canShowCaptcha = computed(() => {
  // Only for user and when captcha is active
  return toBool(bms?.settings?.BmsCommentCaptcha) && !userIsAdmin.value;
});

function setFile(value: File) {
  uploadFile.value = value;
}

const onCaptchaUpdated = (captcha_object: any) => {
  captchaId.value = captcha_object.captcha_id;
};

function onCaptchaUserInput(result: any) {
  captchaValidated.value = result.validated;
}

function closeDialog() {
  emit('cancel');
}

function submitComment(values: any, { resetForm }: any) {
  if ((values.accept_privacy_terms && values.accept_terms && captchaValidated.value) || userIsAdmin.value) {
    delete values.captcha_answer;
    delete values.accept_terms;
    delete values.accept_privacy_terms;
    values['visible'] = 1;
    values['messageid'] = props.messageid;
    values['phone'] = user.value?.id;
    values.solved = +!!values.solved;

    submitting.value = true;
    domainRepository
      .updateMessageState({ body: values, file: uploadFile.value ? uploadFile.value.value : null })
      .then((response: any) => {
        resetForm();
        emit('submit');
      })
      .finally(() => {
        submitting.value = false;
      });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_font_awesome_icon, {
        icon: "info",
        class: "flex-shrink-0 me-2"
      }),
      _hoisted_2
    ]),
    _createVNode(WdwDynbox, {
      title: "ÖFFENTLICHER KOMMENTAR",
      config: { showControls: false },
      minimize: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, {
            icon: "info",
            class: "flex-shrink-0 me-2"
          }),
          _hoisted_4
        ]),
        _createVNode(_unref(Form), { onSubmit: submitComment }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(FormControlTextarea), {
                label: "Kommentar",
                name: "text",
                code: "comment",
                error: "Kommentar kann nicht leer sein",
                textLimitConfig: { showRemainingCharactersInfo: false },
                required: true,
                rows: 5
              }),
              _createVNode(_unref(FormControlFile), {
                name: "attachment-file",
                code: "attachment-file",
                label: "Foto (optional)",
                accepts: "image/*",
                onValidate: setFile
              }),
              (_unref(user)?.type !== 'admin')
                ? (_openBlock(), _createBlock(_unref(FormControlCheckbox), {
                    key: 0,
                    label: "Dieses Anliegen wurde bereits erledigt und kann geschlossen werden.",
                    name: "solved",
                    code: "solved"
                  }))
                : _createCommentVNode("", true),
              (_unref(canShowCaptcha))
                ? (_openBlock(), _createBlock(Captcha, {
                    key: 1,
                    validateOnInput: true,
                    onValidateOnInput: onCaptchaUserInput,
                    onCaptchaUpdated: onCaptchaUpdated,
                    serverError: captchaError.value,
                    ref_key: "captcha",
                    ref: captcha,
                    id: "captcha"
                  }, null, 8, ["serverError"]))
                : _createCommentVNode("", true),
              (!_unref(userIsAdmin))
                ? (_openBlock(), _createBlock(_unref(FormControlCheckbox), {
                    key: 2,
                    label: "Ich habe die Nutzungsbedingungen gelesen und werde mich an die Regeln halten.",
                    name: "accept_terms",
                    required: true,
                    code: "accept_terms"
                  }))
                : _createCommentVNode("", true),
              (!_unref(userIsAdmin))
                ? (_openBlock(), _createBlock(_unref(FormControlCheckbox), {
                    key: 3,
                    label: "Ich habe die Datenschutzerklärung gelesen und erkläre mich mit dieser einverstanden.",
                    name: "accept_privacy_terms",
                    required: true,
                    code: "accept_privacy_terms"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-default btn-form-cancel",
              onClick: closeDialog
            }, "Abbrechen"),
            _createElementVNode("button", {
              disabled: submitting.value,
              class: "btn btn-success btn-form-submit btn-submit-filter",
              type: "submit"
            }, " Speichern ", 8, _hoisted_6),
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})